jQuery(document).ready(function () {
    initDnChoices();

    $(document).on('change', '#ticket_general_season_event_type', function (e) {
        var el = $(this);
        var selectedOption = el.find('option:selected');
        var value = parseInt(selectedOption.val(), 10);

        var linkedSeasonEventsSelectContainer = $('#linked_season_events_container');

        if (2 === value) {
            $(linkedSeasonEventsSelectContainer).css('display', 'block');
        } else {
            $(linkedSeasonEventsSelectContainer).css('display', 'none');
        }
    });
});

var initDnChoices = function () {
    $('.dnJs-choices:not(.choices__input)').each(function () {
        var choices = new Choices(this, {
            removeItems: true,
            removeItemButton: true,
            searchFields: ['label'],
            searchResultLimit: $(this).get(0).hasAttribute('data-search-result-limit') ? $(this).get(0).getAttribute('data-search-result-limit') : 6,
            duplicateItemsAllowed: false,

            searchPlaceholderValue: translationTo.search,
            loadingText: translationTo.loadingText,
            noResultsText: translationTo.noResult,
            noChoicesText: translationTo.noResult,
            itemSelectText: translationTo.pressToSelect,
            shouldSort: $(this).get(0).hasAttribute('data-should-not-sort') ? false : true,

            callbackOnCreateTemplates: function (template) {
                return {
                    choice: function (classNames, data) {
                        var t = '';

                        t += '<div class="text-truncate ';
                        t += classNames.item + ' ';
                        t += classNames.itemChoice + ' ';
                        if (data.disabled) {
                            t += classNames.itemDisabled;
                        } else {
                            t += classNames.itemSelectable;
                        }
                        t += '" ';
                        t += 'data-select-text="' + this.config.itemSelectText + '" ';
                        t += 'data-choice ';
                        if (data.disabled) {
                            t += 'data-choice-disabled aria-disabled="true" ';
                        } else {
                            t += 'data-choice-selectable ';
                        }
                        t += 'data-id="' + data.id + '" ';
                        t += 'data-value="' + data.value + '" ';
                        if (data.groupId > 0) {
                            t += 'role="treeitem" ';
                        } else {
                            t += 'role="option" ';
                        }
                        t += '>';

                        if (data.customProperties && data.customProperties.img) {
                            t += '<span><img srcset="';
                            t += data.customProperties.img;
                            t += '" class="dnFormChosenChoices-choices-img"/></span> ';
                        }
                        t += data.label;
                        t += '</div>';

                        return template(t);
                    },
                };
            }
        });

        var label = $(this).attr('data-add-label');
        var link = $(this).attr('data-add-link');

        var labelNewItem = $(this).attr('data-add-new-label');

        /*if (typeof label !== typeof undefined && label !== false && typeof link !== typeof undefined && link !== false) {
            var nr = '<a href="' + link + '" class="dnFormChosenChoices-item-link" target="_blank">' + label + '</a>';
            choices.config.noChoicesText = nr;
            choices.clearChoices();
        }*/

        if ($(this).parent('.choices__inner').find('.choices__item').length) {
            dnJsChoicesAddClass($(this));
        }

        var api = $(this).attr('data-api');
        if (typeof api !== typeof undefined && api !== false) {
            this.addEventListener('search', function (e) {
                $.ajax({
                    url: api,
                    method: "POST",
                    data: { q : e.detail.value },
                    dataType: 'json',
                    beforeSend: function () {
                        choices.clearChoices();
                    },
                    success: function (data) {
                        var newChoices = [];
                        data.forEach(function (element) {
                            newChoices.push({value: element.id, label: element.name, customProperties: {img: element.img ? element.img : null}});
                        });
                        if (typeof label !== typeof undefined && label !== false && typeof link !== typeof undefined && link !== false) {
                            var l = '<div class="dnFormChosenChoices-item-link">' + label + '</div>';
                            newChoices.push({value: 'add-item', label: l, customProperties: {addlink: link, addSearch: e.detail.value}});
                        }
                        if (typeof labelNewItem !== typeof undefined && labelNewItem !== false) {
                            var l = '<div class="dnFormChosenChoices-item-link">"' + e.detail.value + '" ' + labelNewItem + '</div>';
                            newChoices.push({value: 'add-new-item', label: l, customProperties: {addNew: true, addFromSearch: e.detail.value}});
                        }

                        choices.setChoices(newChoices, 'value', 'label', true);
                    }
                });
            }, false);
        }

        this.addEventListener('addItem', function (e) {
            if (e.detail.customProperties && e.detail.customProperties.addlink) {
                var link = e.detail.customProperties.addlink;
                link += '?name=';
                link += e.detail.customProperties.addSearch;
                choices.removeActiveItemsByValue('add-item');
                window.open(link, '_blank');
            } else if (e.detail.customProperties && e.detail.customProperties.addFromSearch) {
                var name = e.detail.customProperties.addFromSearch;
                choices.removeActiveItemsByValue('add-new-item');
                choices.setValue({value: 'add-new-item' + name, label: name});
                choices.clearChoices();
            } else {
                dnJsChoicesAddClass($(this));
            }
        }, false);

        var inputCloned = $(this).closest('.choices').find('input.choices__input');

        inputCloned.focusout(function (e) {
            $(this).val('');
        });

        this.addEventListener('removeItem', function (e) {
            if (!$(this).parent('.choices__inner').find('.choices__item').length) {
                dnJsChoicesRemoveClass($(this));
            }
        }, false);

    });
};

function dnJsChoicesAddClass(e) {
    e.parent('.choices__inner').parent('.choices').addClass('dnjsChoices-hasItem');
}

function dnJsChoicesRemoveClass(e) {
    e.parent('.choices__inner').parent('.choices').removeClass('dnjsChoices-hasItem');
}

$(document).on('loaded.bs.modal', '.dnJs-modal-with-choices', function (e) {
    initDnChoices();
});

$(document).on('loaded.form.ajax', function (e) {
    initDnChoices();
});
